<div class="row d-flex justify-content-between">
  <div class="col-md-8 search-bar mb-2">
    <input
      type="text"
      class="search-input form-control"
      placeholder="Filtrelemek istediğiniz hizmet adını giriniz..."
      [(ngModel)]="searchText"
      (ngModelChange)="onSearch()"
    />
  </div>

  <div *ngIf="!(isReadOnly || isCaseApproved)" class="col-md-4 d-flex justify-content-end">
    <button class="btn btn-info" (click)="openServicePopup()">
      {{ "case.service-informations.add-service" | translate }}
    </button>
  </div>
</div>
<hr />

@if(filteredServices.length>0){
<div class="table-container">
  <table class="service-table">
    <thead>
      <tr>
        <th scope="col">{{ "case.service-informations.service" | translate }}</th>
        <th scope="col">{{ "case.service-informations.quantity" | translate }}</th>
        <th scope="col">{{ "case.service-informations.unit-price" | translate }}</th>
        <th scope="col">{{ "case.service-informations.price" | translate }}</th>
        <th scope="col">{{ "case.service-informations.last-price" | translate }}</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item of filteredServices">
        <tr class="service-row">
          <td class="service-cell">
            <div class="service-name">{{ item?.serviceName }}</div>
            <div class="service-code">{{ item?.serviceCode }}</div>
          </td>
          <td class="service-cell">
            @if(isReadOnly || isCaseApproved){
            <app-readonly-input
              [value]="item?.quantity?.toString()"
            ></app-readonly-input>
            }@else {
            <input
              type="number"
              class="quantity-input"
              [(ngModel)]="item.quantity"
              (ngModelChange)="updateServicePriceItemQuantity(item)"
              appPreventNegativeInput
              [min]="1"
            />
            }
          </td>
          <td class="service-cell-money">
            <div class="price">{{ item?.unitPrice | numberComma }} ₺</div>
          </td>
          <td class="service-cell-money">
            <div class="price">{{ item?.totalPrice | numberComma }} ₺</div>
          </td>
          <td class="service-cell-money">
            <div class="price">{{ item?.lastPrice | numberComma }} ₺</div>
          </td>
          <td class="service-cell">
            <button
              *ngIf="!(isReadOnly || isCaseApproved)"
              class="action-button delete-btn me-4"
              (click)="deleteService(item.serviceId)"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
            <button
              class="action-button expand-btn"
              (click)="toggleExpand(item)"
            >
              <i
                [class]="
                  item.expanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
                "
              ></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="item.expanded" class="accordion-row">
          <td colspan="6" style="padding: 0">
            <div class="expanded-content" [class.expanded]="item.expanded">
              <div class="expanded-cards">
                <!-- Kapı F. / Üye F. Card -->
                <div class="info-card">
                  <div class="info-card-header">
                    {{ "case.service-informations.gate-box" | translate }}
                  </div>
                  <div class="info-card-body">
                    <div
                      class="info-value"
                      [ngClass]="
                        item?.memberPrice?.originalPrice === null ||
                        item?.memberPrice?.originalPrice === undefined
                          ? 'font-weight-bold'
                          : undefined
                      "
                    >
                      {{
                        item?.gatePrice?.originalPrice === null ||
                        item?.gatePrice?.originalPrice === undefined
                          ? "-"
                          : (item?.gatePrice?.originalPrice | numberComma) +
                            " " +
                            item?.gatePrice?.icon
                      }}
                    </div>
                    <div class="info-card-divider"></div>
                    <div
                      class="info-value"
                      [ngClass]="
                        item?.memberPrice?.originalPrice !== null &&
                        item?.memberPrice?.originalPrice !== undefined
                          ? 'font-weight-bold'
                          : undefined
                      "
                    >
                      {{
                        item?.memberPrice?.originalPrice === null ||
                        item?.memberPrice?.originalPrice === undefined
                          ? "-"
                          : (item?.memberPrice?.originalPrice | numberComma) +
                            " " +
                            item?.memberPrice?.icon
                      }}
                    </div>
                  </div>
                </div>

                <!-- Provizyon Card -->
                <div class="info-card">
                  <div class="info-card-header">
                    @if (item.ruleOfPopups.provision && !(isReadOnly || isCaseApproved)) {
                    <button class="text-button" (click)="openProvisionPopup()">
                      {{
                        "case.service-informations.provision-box" | translate
                      }}
                    </button>
                    }@else {

                    {{ "case.service-informations.provision-box" | translate }}
                    }
                  </div>
                  <div class="info-card-body">
                    <div class="info-percentage">
                      {{
                        item?.provision?.percentage === null ||
                        item?.provision?.percentage === undefined
                          ? "-"
                          : (item?.provision?.percentage | numberComma) + "%"
                      }}
                    </div>
                    <div class="info-card-divider"></div>
                    <div class="info-value">
                      {{
                        item?.provision?.price !== null &&
                        item?.provision?.price !== undefined
                          ? (item?.provision?.price | numberComma) + " ₺"
                          : "-"
                      }}
                    </div>
                  </div>
                </div>

                <!-- İndirim Card -->
                <div class="info-card">
                  <div class="info-card-header">
                    @if (item.ruleOfPopups.rowDiscount && !(isReadOnly || isCaseApproved)) {
                    <button
                      class="text-button"
                      (click)="openRowDiscountPopup(item)"
                    >
                      {{ "case.service-informations.discount-box" | translate }}
                    </button>
                    }@else {
                    {{ "case.service-informations.discount-box" | translate }}
                    }
                  </div>
                  <div class="info-card-body">
                    <div class="info-percentage">
                      {{
                        item?.discount?.percentage === null ||
                        item?.discount?.percentage === undefined
                          ? "-"
                          : (item?.discount?.percentage | numberComma) + "%"
                      }}
                    </div>
                    <div class="info-card-divider"></div>
                    <div class="info-value">
                      {{
                        item?.discount?.price !== null &&
                        item?.discount?.price !== undefined
                          ? (item?.discount?.price | numberComma) + " ₺"
                          : "-"
                      }}
                    </div>
                  </div>
                </div>

                <!-- Dip İndirim Card -->
                <div class="info-card">
                  <div class="info-card-header">
                    {{ "case.service-informations.bottom-box" | translate }}
                  </div>
                  <div class="info-card-body">
                    <div class="info-percentage">
                      {{
                        item?.bottomDiscount?.percentage === null ||
                        item?.bottomDiscount?.percentage === undefined
                          ? "-"
                          : (item?.bottomDiscount?.percentage | numberComma) +
                            "%"
                      }}
                    </div>
                    <div class="info-card-divider"></div>
                    <div class="info-value">
                      {{
                        item?.bottomDiscount?.price !== null &&
                        item?.bottomDiscount?.price !== undefined
                          ? (item?.bottomDiscount?.price | numberComma) + " ₺"
                          : "-"
                      }}
                    </div>
                  </div>
                </div>

                <!-- Esnek Fiyat Card -->
                <div class="info-card">
                  <div class="info-card-header">
                    @if (item.ruleOfPopups.flexiblePrice && !(isReadOnly || isCaseApproved)) {
                    <button
                      class="text-button"
                      (click)="openFlexiblePricePopup(item)"
                    >
                      {{
                        "case.service-informations.flexible-price-box"
                          | translate
                      }}
                    </button>
                    }@else {
                    {{
                      "case.service-informations.flexible-price-box" | translate
                    }}

                    }
                  </div>
                  <div class="info-card-body">
                    <div class="info-percentage">
                      @if(item?.flexiblePrice?.isFlexible){
                      <i
                        class="fa-solid fa-circle-check fa-xl"
                        style="color: #63e6be"
                      ></i>
                      }@else{
                      <i
                        class="fa-solid fa-circle-xmark fa-xl"
                        style="color: #de1b1b"
                      ></i>
                      }
                    </div>
                    <div class="info-card-divider"></div>
                    <div class="info-value">
                      {{
                        item?.flexiblePrice?.price !== null &&
                        item?.flexiblePrice?.price !== undefined
                          ? (item?.flexiblePrice?.price | numberComma) + " ₺"
                          : "-"
                      }}
                    </div>
                  </div>
                </div>

                <!-- Ücretsiz Card -->
                <div class="info-card" style="min-width: 0px">
                  <div class="info-card-header">
                    {{ "case.service-informations.free-box" | translate }}
                  </div>
                  <div class="info-card-body justify-content-center">
                    <div>
                      @if(item?.givenForFree){
                      <i
                        class="fa-solid fa-circle-check fa-xl"
                        style="color: #63e6be"
                      ></i>
                      }@else{
                      <i
                        class="fa-solid fa-circle-xmark fa-xl"
                        style="color: #de1b1b"
                      ></i>
                      }
                    </div>
                    <div style="height: 30px"></div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<div class="fixed-footer">
  <div class="footer-header" (click)="toggleFooter()" role="button"  tabindex="-1">
    <div class="footer-left">
      <button
        class="tab-button me-2"
         *ngIf="!(isReadOnly || isCaseApproved)"
        (click)="openProvisionPopup(); $event.stopPropagation()"
      >
        {{ "case.service-informations.provision-process" | translate }}
      </button>
      <button
       *ngIf="!(isReadOnly || isCaseApproved)"
        class="tab-button"
        (click)="openBottomDiscountPopup(); $event.stopPropagation()"
      >
        {{ "case.service-informations.bottom-discount-process" | translate }}
      </button>
    </div>
    <div class="footer-info">
      <div class="footer-total">
        <span class="footer-total-label"
          >{{
            "case.service-informations.number-of-service" | translate
          }}:</span
        >
        <span class="footer-total-value text-center">{{
          info?.numberOfServices ?? "-"
        }}</span>
      </div>
      <div class="footer-total">
        <span class="footer-total-label"
          >{{ "case.service-informations.total-price" | translate }}:</span
        >
        <span class="footer-total-value">
          {{ info?.totalPrice ? (info.totalPrice | numberComma) : "-" }} ₺
        </span>
      </div>
      <div class="footer-total">
        <span class="footer-total-label"
          >{{ "case.service-informations.last-price" | translate }}:</span
        >
        <span class="footer-total-value">
          {{ info?.lastPrice ? (info.lastPrice | numberComma) : "-" }} ₺
        </span>
      </div>
    </div>
    <div class="footer-chevron-container">
      <span class="footer-chevron" [class.rotated]="isFooterExpanded">▼</span>
    </div>
  </div>

  <div class="footer-content" [class.expanded]="isFooterExpanded">
    <div class="footer-details">
      <div>
        <div class="summary-item">
          <span class="summary-label"
            >{{ "case.service-informations.provision-no" | translate }}:</span
          >
          <span class="summary-value">{{ info?.provisionNo || "-" }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label"
            >{{
              "case.service-informations.provision-institution" | translate
            }}:</span
          >
          <span class="summary-value">{{ provisionInstitution ?? "-" }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label"
            >{{
              "case.service-informations.provision-description" | translate
            }}:</span
          >
          <span class="summary-value">{{
            info?.provisionDescription ?? "-"
          }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label"
            >{{
              "case.service-informations.bottom-discount-description" | translate
            }}:</span
          >
          <span class="summary-value">{{
            info?.bottomDiscountDescription ?? "-"
          }}</span>
        </div>
      </div>

      <div id="summary-price">
        <div class="summary-item">
          <span class="summary-label">
            {{ "case.service-informations.total-price" | translate }}:</span
          >
          <span class="summary-value"
            >{{
              info?.totalPrice ? (info.totalPrice | numberComma) : "-"
            }}
            ₺</span
          >
        </div>
        <div class="summary-item">
          <span class="summary-label">
            {{
              "case.service-informations.total-provision-price" | translate
            }}:</span
          >
          <span class="summary-value"
            >{{
              info?.totalProvisionPrice
                ? (info.totalProvisionPrice | numberComma)
                : "-"
            }}
            ₺</span
          >
        </div>
        <div class="summary-item">
          <span class="summary-label">
            {{
              "case.service-informations.total-discount-price" | translate
            }}:</span
          >
          <span class="summary-value"
            >{{
              info?.totalDiscountPrice
                ? (info.totalDiscountPrice | numberComma)
                : "-"
            }}
            ₺</span
          >
        </div>
        <div class="summary-item">
          <span class="summary-label">
            {{
              "case.service-informations.bottom-discount-price" | translate
            }}:</span
          >
          <span class="summary-value">
            {{
              info?.bottomDiscountPrice
                ? (info.bottomDiscountPrice | numberComma)
                : "-"
            }}
            ₺</span
          >
        </div>
        <div class="summary-item">
          <span class="summary-label">
            {{ "case.service-informations.last-price" | translate }}:</span
          >
          <span class="summary-value total-value"
            >{{
              info?.lastPrice ? (info?.lastPrice | numberComma) : "-"
            }}
            ₺</span
          >
        </div>
      </div>
    </div>
  </div>
</div>

} @else {
<app-core-info-messages
  type="info"
  [closable]="true"
  [message]="'case.service-informations.no-selected-service-yet' | translate"
></app-core-info-messages>
}

<app-core-popup
  [header]="'case.service-informations.calculate-discount' | translate"
  [dialogStyle]="{ width: '30vw' }"
  [saveText]="'common.save' | translate"
  (chooseOn)="saveRowDiscount()"
  [showSecondButton]="showRemoveButton ? true : false"
  [secondButtonText]="'common.remove' | translate"
  (secondButtonChooseOn)="removeRowDiscount()"
  (closeOn)="closeRowDiscount()"
  #rowDiscountPopup
>
  <div class="row">
    <div class="col-12 mb-3">
      <div class="form-group row align-items-center">
        <label class="col-3" for="">
          {{ "case.service-informations.price" | translate }}:
        </label>
        <div class="col-9">
          <app-readonly-input
            class="w-100"
            [value]="(rowDiscount.price | numberComma) + ' ₺'"
          ></app-readonly-input>
        </div>
      </div>
    </div>

    <div class="col-12 mb-3">
      <div class="row">
        <div class="col-9 d-flex justify-content-between">
          <div class="d-flex align-items-center gap-2">
            <label class="mb-0" for="radioPercentage">
              {{ "case.service-informations.discount-rate" | translate }}
            </label>
            <input
              type="radio"
              class="form-check-input"
              [(ngModel)]="rowDiscount.radiobutton"
              [value]="'percentage'"
              id="radioPercentage"
            />
          </div>
          <div class="d-flex align-items-center gap-2">
            <label class="mb-0" for="radioPrice">
              {{ "case.service-informations.discount-price" | translate }}
            </label>
            <input
              type="radio"
              class="form-check-input"
              [(ngModel)]="rowDiscount.radiobutton"
              [value]="'price'"
              id="radioPrice"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 mb-3">
      <div class="form-group row align-items-center">
        <label class="col-3" for="">
          {{ "case.service-informations.discount-rate" | translate }}:
        </label>
        <div class="col-9">
          @if(rowDiscount.radiobutton==='percentage'){
          <input
            type="number"
            [(ngModel)]="rowDiscount.percentage"
            [max]="100"
            [min]="0"
            [inputType]="'float'"
            appPreventNegativeInput
            (ngModelChange)="calculateRowFromPercentage()"
            class="form-control"
          />
          }@else {
          <app-readonly-input
            class="w-100"
            [value]="rowDiscount.percentage | numberComma"
          ></app-readonly-input>
          }
        </div>
      </div>
    </div>

    <div class="col-12 mb-3">
      <div class="form-group row align-items-center">
        <label class="col-3" for="">
          {{ "case.service-informations.discount-price" | translate }}:
        </label>
        <div class="col-9">
          @if(rowDiscount.radiobutton==='price'){
          <input
            type="number"
            [(ngModel)]="rowDiscount.discountPrice"
            (ngModelChange)="calculateRowFromDiscountPrice()"
            appPreventNegativeInput
            [min]="0"
            [max]="rowDiscount.price"
            [inputType]="'float'"
            class="form-control"
          />
          }@else {
          <app-readonly-input
            class="w-100"
            [value]="rowDiscount.discountPrice | numberComma"
          ></app-readonly-input>
          }
        </div>
      </div>
    </div>

    <div class="col-12 mb-3">
      <div class="form-group row align-items-center">
        <label class="col-3" for="">
          {{ "case.service-informations.discount-last-price" | translate }}:
        </label>
        <div class="col-9">
          <app-readonly-input
            class="w-100"
            [value]="(rowDiscount.finalPrice | numberComma) + ' ₺'"
          ></app-readonly-input>
        </div>
      </div>
    </div>
  </div>
</app-core-popup>

<app-core-popup
  [header]="'case.service-informations.flexible-price-header' | translate"
  [dialogStyle]="{ width: '30vw' }"
  [saveText]="'common.save' | translate"
  (chooseOn)="saveFlexiblePricePopup()"
  (closeOn)="closeFlexiblePricePopup()"
  [showSecondButton]="showRemoveButton ? true : false"
  [secondButtonText]="'Kaldır'"
  (secondButtonChooseOn)="removeFlexible()"
  #flexiblePricePopup
>
  <div class="row">
    <div class="col-12 mb-3">
      <div class="form-group d-flex align-items-center justify-content-between">
        <label class="mb-0" for="">{{
          "case.service-informations.flexible-price-box" | translate
        }}</label>
        <input
          type="number"
          [(ngModel)]="flexiblePrice"
          appPreventNegativeInput
          [min]="0"
          [inputType]="'float'"
          class="form-control w-75"
        />
      </div>
    </div>
  </div>
</app-core-popup>

<app-core-popup
  [header]="
    'case.service-informations.calculate-bottom-discount-header' | translate
  "
  [dialogStyle]="{ width: '30vw' }"
  [saveText]="'common.save' | translate"
  (chooseOn)="saveBottomDiscount()"
  [showSecondButton]="showRemoveButton ? true : false"
  [secondButtonText]="'common.remove' | translate"
  (secondButtonChooseOn)="removeBottomDiscount()"
  (closeOn)="closeBottomDiscount()"
  #bottomDiscountPopup
>
  <div class="row">
    <div class="col-12 mb-3">
      <div class="form-group row align-items-center">
        <label class="col-3" for="">
          {{ "case.service-informations.price" | translate }}:
        </label>
        <div class="col-9">
          <app-readonly-input
            class="w-100"
            [value]="(bottomDiscount.price | numberComma) + ' ₺'"
          ></app-readonly-input>
        </div>
      </div>
    </div>

    <div class="col-12 mb-3">
      <div class="row">
        <div class="col-9 d-flex justify-content-between">
          <div class="d-flex align-items-center gap-2">
            <label class="mb-0" for="bottomRadioPercentage">
              {{ "case.service-informations.discount-rate" | translate }}
            </label>
            <input
              class="form-check-input"
              type="radio"
              [(ngModel)]="bottomDiscount.radiobutton"
              [value]="'rate'"
              id="bottomRadioPercentage"
            />
          </div>

          <div class="d-flex align-items-center gap-2">
            <label class="mb-0" for="bottomRadioPrice">
              {{ "case.service-informations.discount-price" | translate }}
            </label>
            <input
              class="form-check-input"
              type="radio"
              [(ngModel)]="bottomDiscount.radiobutton"
              [value]="'total'"
              id="bottomRadioPrice"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="form-group row align-items-center">
        <label class="col-3" for="">
          {{ "case.service-informations.discount-rate" | translate }}:
        </label>
        <div class="col-9">
          @if(bottomDiscount.radiobutton==='rate'){
          <input
            type="number"
            [(ngModel)]="bottomDiscount.percentage"
            [max]="100"
            [min]="0"
            [inputType]="'float'"
            appPreventNegativeInput
            (ngModelChange)="calculateBottomFromPercentage()"
            class="form-control"
          />
          } @else {
          <app-readonly-input
            class="w-100"
            [value]="bottomDiscount.percentage | numberComma"
          ></app-readonly-input>
          }
        </div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="form-group row align-items-center">
        <label class="col-3" for="">
          {{ "case.service-informations.discount-price" | translate }}:
        </label>
        <div class="col-9">
          @if(bottomDiscount.radiobutton==='total'){
          <input
            type="number"
            [(ngModel)]="bottomDiscount.discountPrice"
            (ngModelChange)="calculateBottomFromDiscountPrice()"
            appPreventNegativeInput
            [min]="0"
            [max]="bottomDiscount.price"
            [inputType]="'float'"
            class="form-control"
          />
          } @else {
          <app-readonly-input
            class="w-100"
            [value]="bottomDiscount.discountPrice | numberComma"
          ></app-readonly-input>
          }
        </div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="form-group row align-items-center">
        <label class="col-3" for="">
          {{ "case.service-informations.discount-last-price" | translate }}:
        </label>
        <div class="col-9">
          <app-readonly-input
            class="w-100"
            [value]="(bottomDiscount.finalPrice | numberComma) + ' ₺'"
          ></app-readonly-input>
        </div>
      </div>
    </div>
    <div class="col-12 mb-3" *ngIf="bottomDiscount?.radiobutton === 'rate' || bottomDiscount?.radiobutton === 'total' || bottomDiscount.description">
      <label class="col-3" for="">
        {{ "case.service-informations.bottom-discount-description" | translate }}
      </label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="bottomDiscount.description"
        placeholder="Açıklama giriniz"
      />
    </div>
  </div>
</app-core-popup>

<app-core-popup
  [header]="'case.service-informations.calculate-provision-header' | translate"
  [dialogStyle]="{ width: '70vw' }"
  [saveText]="'common.save' | translate"
  (chooseOn)="saveProvisionPopup()"
  (closeOn)="resetProvisionPopupDatas()"
  #provisionPopup
>
  @if(info?.services?.length &&
  (info.services.length!==provision?.services?.length)){
  <app-core-info-messages
    type="info"
    [closable]="true"
    [message]="'case.service-informations.provision-note' | translate"
  ></app-core-info-messages>
  }

  <div class="row p-2 mb-3">
    <div class="col-md-12">
      <div class="form-group row align-items-center">
        <label class="col-md-4 mb-0 required-star" for="">{{
          "case.service-informations.provision-no" | translate
        }}</label>
        <div class="col-md-8">
          <input type="text" [(ngModel)]="provision.no" class="form-control" />
        </div>
      </div>
    </div>
  </div>

  <!-- Provizyon Kurum -->
  <div class="row p-2 mb-3">
    <div class="col-md-12">
      <div class="form-group row align-items-center">
        <label class="col-md-4 mb-0 required-star" for="">{{
          "case.service-informations.provision-institution" | translate
        }}</label>
        <div class="col-md-8">
          <p-dropdown
            [options]="provionalInstitutions"
            [(ngModel)]="provision.institution"
            [filter]="true"
            appendTo="body"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </div>

  <div class="row p-2 mb-3">
    <div class="col-md-12">
      <div class="form-group row align-items-center">
        <label class="col-md-4 mb-0" for="">{{
          "case.service-informations.provision-description" | translate
        }}</label>
        <div class="col-md-8">
          <textarea
            [(ngModel)]="provision.description"
            class="form-control"
            rows="3"
            placeholder="..."
          ></textarea>
        </div>
      </div>
    </div>
  </div>

  <hr />
  <div class="row p-2 d-flex align-items-center justify-content-around">
    <div class="col-md-4">
      <div class="d-flex align-items-center">
        <span class="mx-3">
          <input
            class="form-check-input p-0 m-0"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault1"
            [(ngModel)]="provision.selectedOption"
            (ngModelChange)="radioButtonChange()"
            [value]="'percentage'"
          />
          <label class="form-check-label bold" for="flexRadioDefault1">
            {{ "case.service-informations.provision-rate" | translate }}
          </label>
        </span>
        <span>
          <input
            class="form-check-input"
            type="radio"
            name="flexRadioDefault"
            [(ngModel)]="provision.selectedOption"
            [value]="'price'"
          />
          <label class="form-check-label bold" for="flexRadioDefault1">
            {{
              "case.service-informations.provision-discount-price" | translate
            }}
          </label>
        </span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="row d-flex align-items-center">
        @if(provision.selectedOption==='percentage'){
        <label class="col-md-3 bold" for=""
          >{{
            "case.service-informations.provision-rate" | translate
          }}
          (%):</label
        >
        <div class="col-md-9">
          <input
            type="number"
            [(ngModel)]="provision.percentage"
            [max]="100"
            [min]="0"
            [inputType]="'float'"
            appPreventNegativeInput
            class="form-control"
          />
        </div>
        }@else {
        <label class="col-md-3 bold" for="">
          {{ "case.service-informations.provision-discount-price" | translate }}
          (₺):</label
        >
        <div class="col-md-9">
          <input
            type="number"
            [(ngModel)]="provision.discountPrice"
            [max]="maxProvisionTotalPrice"
            [min]="0"
            [inputType]="'float'"
            appPreventNegativeInput
            class="form-control"
          />
        </div>

        }
      </div>
    </div>

    <div class="col-md-2 d-flex justify-content-center">
      <button
        type="button"
        class="btn btn-sm btn-success me-2"
        (click)="applyProvisionAll()"
      >
        {{ "common.apply" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-sm btn-danger"
        (click)="clearProvisionAll()"
      >
        {{ "common.clear" | translate }}
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-12">
      <div class="table-responsive active-projects user-tbl dt-filter">
        <div id="user-tbl_wrapper" class="dataTables_wrapper no-footer">
          <p-table
            [value]="provision.services"
            [(selection)]="provision.selectedServices"
            scrollHeight="30rem"
            dataKey="serviceId"
            [rowHover]="true"
            responsiveLayout="stack"
            paginatorDropdownAppendTo="body"
            [lazy]="true"
            [scrollable]="true"
            (onRowUnselect)="provisionSelectionRemoved($event)"
            (onHeaderCheckboxToggle)="onProvisionSelectionChange($event)"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 10%;" scope="col"><p-tableHeaderCheckbox /></th>
                <th style="width: 30%;" scope="col">
                  {{ "case.service-informations.service-name" | translate }}
                </th>
                <th style="width: 15%;" scope="col">
                  {{ "case.service-informations.price" | translate }}
                </th>
                <th style="width: 15%;" scope="col">
                  {{ "case.service-informations.provision-rate" | translate }} %
                </th>
                <th style="width: 15%;" scope="col">
                  {{ "case.service-informations.provision-price" | translate }}
                </th>
                <th style="width: 15%;" scope="col">
                  {{
                    "case.service-informations.discount-last-price" | translate
                  }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-service>
              <tr style="height: 4rem">
                <td>
                  <p-tableCheckbox [value]="service" />
                </td>
                <td>{{ service?.serviceName }}</td>
                <td>{{ (service?.totalPrice | numberComma) + " ₺" }}</td>
                <td>
                  <ng-container
                    *ngIf="
                      provision.selectedServices?.indexOf(service) !== -1;
                      else displayPercentage
                    "
                  >
                  @if(provision.selectedOption==='percentage'){
                    <input
                    type="number"
                    [(ngModel)]="service.provision.percentage"
                    [max]="100"
                    [min]="0"
                    [inputType]="'float'"
                    appPreventNegativeInput
                    [maxFractionDigits]="2"
                    (ngModelChange)="
                      calculateProvisionFromPercentage(service)
                    "
                    class="form-control w-75"
                  />
                    } @else {
                    <app-readonly-input
                      class="w-100"
                      [value]="service.provision.percentage | numberComma"
                    ></app-readonly-input>
                    }
                  </ng-container>
                  <ng-template #displayPercentage>
                    {{
                      service?.provision?.percentage
                        ? (service?.provision?.percentage | numberComma) + " %"
                        : "-"
                    }}
                  </ng-template>
                </td>

                <!-- Provizyon Tutarı Kolonu -->
                <td>
                  <ng-container
                    *ngIf="
                      provision.selectedServices?.indexOf(service) !== -1;
                      else displayPrice
                    "
                  >

                  @if(provision.selectedOption==='price'){
                    <input
                    type="number"
                    [(ngModel)]="service.provision.price"
                    (ngModelChange)="calculateProvisionFromPrice(service)"
                    appPreventNegativeInput
                    [maxFractionDigits]="2"
                    [min]="0"
                    [max]="service.totalPrice"
                    [inputType]="'float'"
                    class="form-control w-75"
                  />
                    } @else {
                    <app-readonly-input
                      class="w-100"
                      [value]="(service.provision.price | numberComma)+ '₺'"
                    ></app-readonly-input>
                    }

                  </ng-container>
                  <ng-template #displayPrice>
                    {{
                      service?.provision?.price
                        ? (service?.provision?.price | numberComma) + " ₺"
                        : "-"
                    }}
                  </ng-template>
                </td>
                <td>{{ (service?.lastPrice | numberComma) + " ₺" }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</app-core-popup>

<app-service-price-popup
  (saveOn)="onSaveServices($event)"
  [priceTypeId]="priceType?.value"
  [priceTypeLabel]="priceType?.label ?? ''"
  [date]="caseCreatedAt"
  #servicePopup
></app-service-price-popup>
